'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
cbBackgroundImage.$inject = ['$window', 'BreakpointsConstants', 'ImgixService'];
var _module = angular.module('cb.image.cbBackgroundImage', []);

_module.directive('cbBackgroundImage', cbBackgroundImage);

exports.default = _module;

/**
 * CB-Background-Image directive
 * Simple directive to add an background image to an element.
 *
 * Usage: add attribute 'cb-background-directive="<URL>"' to element.
 * '<URL>': specifies the url which points to the image.
 * If it's a relative URL (starts with /) it uses ImageService to get a cached image from imgix.
 * It get's a retina image for 4 breakpoints or the default for large screens
 */

function cbBackgroundImage($window, BreakpointsConstants, ImgixService) {
    return {
        restrict: 'A',
        link: cbBackgroundImageLink
    };

    function cbBackgroundImageLink(scope, element, attr) {
        var style = '';

        if (!attr.cbBackgroundImage || attr.cbBackgroundImage.length === 0) {
            return;
        }

        var imgUrl = attr.cbBackgroundImage;
        var el = element[0];
        var width = 0;

        // Breakpoint * 2 to always load Retina image
        if (el.offsetWidth < BreakpointsConstants.sm) {
            width = BreakpointsConstants.sm * 2;
        } else if (el.offsetWidth < BreakpointsConstants.md) {
            width = BreakpointsConstants.md * 2;
        } else if (el.offsetWidth < BreakpointsConstants.lg) {
            width = BreakpointsConstants.lg * 2;
        } else if (el.offsetWidth < BreakpointsConstants.xl) {
            width = BreakpointsConstants.xl * 2;
        }

        if (imgUrl.substring(0, 1) === '/') {
            if (width === 0) {
                el.style['background-image'] = 'url(' + ImgixService.getUrl(imgUrl) + ')';
            } else {
                el.style['background-image'] = 'url(' + ImgixService.getUrl(imgUrl, { width: width }) + ')';
            }
        } else {
            el.style['background-image'] = 'url(' + imgUrl + ')';
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/image/cb-background-image.directive.js
// module id = 808
// module chunks = 0